import { Injectable, ErrorHandler } from '@angular/core';
import { Logger } from '../system-services/Logger/Logger.service';

type CustomError = {
    message: string;
    location: string;
    trace: string;
    component: string;
};

@Injectable({ providedIn: 'root' })
export class PIErrorHandler extends ErrorHandler {
    constructor(private logger: Logger) {
        super();
    }
    handleError(error: any) {
        super.handleError(error);
        const customError: CustomError = {
            message: error.message,
            location: window.location.pathname,
            trace: error.stack,
            component:
                error.ngDebugContext &&
                error.ngDebugContext.component &&
                error.ngDebugContext.component.constructor &&
                error.ngDebugContext.component.constructor.name
        };

        if (!this.ignoreError(customError)) {
            this.logger.logError('Angular Error', customError);
        }
    }

    /**
     * Right now this will help us stop spamming the server with every single
     * time the user gets an error because they get a 404 or a 401 because their
     * auth has expired or whatever.
     */
    private ignoreError(error: CustomError): boolean {
        if (
            (error && error.message.includes('Request Error')) ||
            // These stack traces never include anything useful to actually debug
            // and are usually caused by 404s and other stuff. WE should get rid
            // of them but in the meantime they shouldn't be flooding our logs.
            error.message.includes(
                'Uncaught (in promise): [object Undefined]'
            ) ||
            // This doesn't happen in prod but it makes it easier to check that
            // this logic is working in showtime
            error.message.includes(
                'ExpressionChangedAfterItHasBeenCheckedError'
            )
        ) {
            return true;
        }
        return false;
    }
}
